import React from "react";
import MainLayout from "../../components/Layouts";
import ShopDetails from "../../components/Shop/Details";

const ShopDetailsPage = () => {
  return (
    <MainLayout>
<h1>okk</h1>
    </MainLayout>
  );
};

export default ShopDetailsPage;
